module.exports = {
  serverUrls: {
    // useUrl: "https://localhost:44338/", // 로컬
    useUrl: "https://dongsungprintingmes.com:8080/", // 운영
    // useUrl: "http://13.209.38.129/", // 테스트
    deployVersion: "20241031.01",
  },
  urls: {
    login: "api/Account/GetToken",
    LogOut: "Account/LogOut",
    GetMenuList: "api/Account/GetMenuList",
    logic: {
      Common: {
        GetCode: "Common/GetCode",
        GetMakingKey: "Common/GetMakingKey",
        GetCustList: "Common/GetCustList",
        GetItemList: "Common/GetItemList",
        GetItemList2: "Common/GetItemList2",
        GetItemList3: "Common/GetItemList3",
        GetItemList4: "Common/GetItemList4",
        GetStockList: "Common/GetStockList",
        GetUserList: "Common/GetUserList",
        GetProc: "Common/GetProc",
        GetMachine: "Common/GetMachine",
        GetWh: "Common/GetWh",
        SavePassword: "Common/SavePassword",
        LogOut: "Common/LogOut",
      },
      BarCode: {
        PrintSetting3: "BarCode/Print_Setting3",
      },
      Bases: {
        BM10010: {
          BM10010: "BM10010",
          CheckCode: "BM10010/CheckCode",
          Create: "BM10010/Create",
          Delete: "BM10010/Delete",
        },
        BM10020: {
          GetMember: "BM10020/GetMember",
          GetGroup: "BM10020/GetGroup",
          CheckUserId: "BM10020/CheckUserId",
          CreateMember: "BM10020/CreateMember",
          CreateGroupMember: "BM10020/CreateGroupMember",
          UpdatePassword: "BM10020/UpdatePassword",
        },
        BM10030: {
          GetGroup: "BM10030/GetGroup",
          GetAuthGroup: "BM10030/GetAuthGroup",
          CheckAuthGroupCd: "BM10030/CheckAuthGroupCd",
          CheckMenu: "BM10030/CheckMenu",
          CreateGroup: "BM10030/CreateGroup",
          CreateAuthGroup: "BM10030/CreateAuthGroup",
          DeleteGroup: "BM10030/DeleteGroup",
          DeleteAuthGroup: "BM10030/DeleteAuthGroup",
        },
        BM10031: {
          GetMember: "BM10031/GetMember",
          GetAuthMember: "BM10031/GetAuthMember",
          CreateAuthMember: "BM10031/CreateAuthMember",
          DeleteAuthMember: "BM10031/DeleteAuthMember",
        },
        BM10040: {
          GetCustMst: "BM10040/GetCustMst",
          CheckCustCd: "BM10040/CheckCustCd",
          CreateCustMst: "BM10040/CreateCustMst",
          DeleteCustMst: "BM10040/DeleteCustMst",
          FileSave: "BM10040/FileSave",
          FileDownload: "BM10040/FileDownload",
          FileDelete: "BM10040/FileDelete",
        },
        BM10050: {
          GetItemMst: "BM10050/GetItemMst",
          CheckItemCd: "BM10050/CheckItemCd",
          CreateItemMst: "BM10050/CreateItemMst",
          DeleteItemMst: "BM10050/DeleteItemMst",
          FileDownload: "BM10050/FileDownload",
        },
        BM10060: {
          GetMenus: "BM10060/GetMenus",
          GetMenusDtl: "BM10060/GetMenusDtl",
          CheckCode: "BM10060/CheckCode",
          CheckCode1: "BM10060/CheckCode1",
          CreateMenus: "BM10060/CreateMenus",
          CreateMenusFuncs: "BM10060/CreateMenusFuncs",
        },
        BM10070: {
          GetMenus: "BM10070/GetMenus",
          GetLanguage: "BM10070/GetLanguage",
          CheckCode: "BM10070/CheckCode",
          CreateLanguage: "BM10070/CreateLanguage",
        },
        BM10080: {
          GetProcess: "BM10080/GetProcess",
          CheckCode: "BM10080/CheckCode",
          Create: "BM10080/Create",
          Delete: "BM10080/Delete",
        },
        BM10090: {
          GetWh: "BM10090/GetWh",
          CheckCode: "BM10090/CheckCode",
          Create: "BM10090/Create",
          Delete: "BM10090/Delete",
        },
        BM10100: {
          GetMachine: "BM10100/GetMachine",
          CheckCode: "BM10100/CheckCode",
          Create: "BM10100/Create",
          Delete: "BM10100/Delete",
        },
        BM10110: {
          GetCommunication: "BM10110/GetCommunication",
          CheckCode: "BM10110/CheckCode",
          Create: "BM10110/Create",
          Delete: "BM10110/Delete",
        },
        BM10120: {
          Create: "BM10120/Create",
          Serach: "BM10120/Serach",
          DeleteItemBoard: "BM10120/DeleteItemBoard",
        },
      },
      Sales: {
        SM10010: {
          GetSalesOrders: "SM10010/GetSalesOrders",
          GetSalesOrderItemdtls: "SM10010/GetSalesOrderItemdtls",
          CreateSalesOrders: "SM10010/CreateSalesOrders",
          CreateSalesOrderItemdtls: "SM10010/CreateSalesOrderItemdtls",
          DeleteSalesOrders: "SM10010/DeleteSalesOrders",
          DeleteSalesOrderItemdtls: "SM10010/DeleteSalesOrderItemdtls",
        },
        SM10020: {
          GetSalesOrders: "SM10020/GetSalesOrders",
        },
        SM10030: {
          GetSalesDelivStatus: "SM10030/GetSalesDelivStatus",
        },
        SM10040: {
          GetSalesOrders: "SM10040/GetSalesOrders",
          GetSalesDelivOrders: "SM10040/GetSalesDelivOrders",
          GetSalesDelivOrderDtls: "SM10040/GetSalesDelivOrderDtls",
          GetSalesDelivOrderItems: "SM10040/GetSalesDelivOrderItems",
          GetStockList: "SM10040/GetStockList",
          CreateDelivOrder: "SM10040/CreateDelivOrder",
          CreateDelivOrderDtl: "SM10040/CreateDelivOrderDtl",
          CreateDeliv: "SM10040/CreateDeliv",
          CreateDelivRemark: "SM10040/CreateDelivRemark",
          CreateRemark: "SM10040/CreateRemark",
          DeleteSaleDeliv: "SM10040/DeleteSaleDeliv",
          CancleDeliv: "SM10040/CancleDeliv",
          GetPrintData: "SM10040/GetPrintData",
          CancleDelivModal: "SM10040/CancleDelivModal",
          GetBarcodeLotno: "SM10040/GetBarcodeLotno",
          CancleBarcodeLotno: "SM10040/CancleBarcodeLotno",
          GetSalesDelivOrdersPDA: "SM10040/GetSalesDelivOrdersPDA",
        },
        SM10050: {
          GetDelivOrders: "SM10050/GetDelivOrders",
          GetPrintStockData: "SM10050/GetPrintStockData",
        },
        SM10051: {
          CreateDelivStatus: "SM10051/CreateDelivStatus",
          CancleDelivStatus: "SM10051/CancleDelivStatus",
        },
      },
      Stock: {
        ST10010: {
          GetStockList: "ST10010/GetStockList",
        },
        ST10020: {
          GetStockList: "ST10020/GetStockList",
          CreateStock: "ST10020/CreateStock",
        },
        ST10030: {
          GetStockList: "ST10030/GetStockList",
          GetMoveStockList: "ST10030/GetMoveStockList",
          Create: "ST10030/Create",
          UpdateMoveStock: "ST10030/UpdateMoveStock",
        },
        ST10040: {
          GetStockList: "ST10040/GetStockList",
        },
        ST10050: {
          GetTranList: "ST10050/GetTranList",
        },
        ST10060: {
          GetTranList: "ST10060/GetTranList",
        },
      },
      Purchase: {
        PM10010: {
          GetPurchaseOrder: "PM10010/GetPurchaseOrder",
          GetPurchaseOrderDtl: "PM10010/GetPurchaseOrderDtl",
          CreatePurchaseOrders: "PM10010/CreatePurchaseOrders",
          CreatePurchaseOrderDtls: "PM10010/CreatePurchaseOrderDtls",
          DeletePurchaseOrderDtls: "PM10010/DeletePurchaseOrderDtls",
          DeletePurchaseOrder: "PM10010/DeletePurchaseOrder",
          GetPrintData: "PM10010/GetPrintData",
          GetStockChk: "PM10010/GetStockChk",
        },
        PM10020: {
          GetPurchaseOrders: "PM10020/GetPurchaseOrders",
          GetPurchaseOrderDtls: "PM10020/GetPurchaseOrderDtls",
        },
        PM10030: {
          GetPurchaseOrderMst: "PM10030/GetPurchaseOrderMst",
          GetPurchaseOrderDtl: "PM10030/GetPurchaseOrderDtl",
          CreatePurchaseStockIn: "PM10030/CreatePurchaseStockIn",
          DeletePurchaseStockIn: "PM10030/DeletePurchaseStockIn",
        },
        PM10040: {
          GetPurchaseStockIns: "PM10040/GetPurchaseStockIns",
        },
      },
      Manufacture: {
        MM10010: {
          GetManuFacturePlan: "MM10010/GetManuFacturePlan",
          GetStockCal: "MM10010/GetStockCal",
          CreateManuFacturePlan: "MM10010/CreateManuFacturePlan",
          DeleteManuFacturePlan: "MM10010/DeleteManuFacturePlan",
        },
        MM10020: {
          GetSalesOrders: "MM10020/GetSalesOrders",
          GetWorkOrder: "MM10020/GetWorkOrder",
          CreateWorkOrder: "MM10020/CreateWorkOrder",
          DeleteWorkOrder: "MM10020/DeleteWorkOrder",
          GetStockItem: "MM10020/GetStockItem",
          DeleteWorkOrderBom: "MM10020/DeleteWorkOrderBom",
          CreateWorkOrderBom: "MM10020/CreateWorkOrderBom",
          GetStockChk: "MM10020/GetStockChk",
          GetPrintData: "MM10020/GetPrintData",
          GetItemBom: "MM10020/GetItemBom",
          GetSalesOrderItemdtls: "MM10020/GetSalesOrderItemdtls",
        },
        MM10030: {
          GetWorkOrder: "MM10030/GetWorkOrder",
          GetWork: "MM10030/GetWork",
          DeleteWork: "MM10030/DeleteWork",
          WorkCancle: "MM10030/WorkCancle",
          BarCodePrint: "MM10030/BarCodePrint",
          GetPrintStockData: "MM10030/GetPrintStockData",
        },
        MM10040: {
          GetWorkOrder: "MM10040/GetWorkOrder",
          GetWorkUsed: "MM10040/GetWorkUsed",
          GetProcInfo: "MM10040/GetProcInfo",
        },
        MM10050: {
          GetItem: "MM10050/GetItem",
          GetItemBom: "MM10050/GetItemBom",
          GetItemBomDtl: "MM10050/GetItemBomDtl",
          CreateBom: "MM10050/CreateBom",
          DeleteBom: "MM10050/DeleteBom",
        },
        MM10060: {
          GetWork: "MM10060/GetWork",
          GetUserInfo: "MM10060/GetUserInfo",
          GetManuWork: "MM10060/GetManuWork",
          WorkCreate: "MM10060/WorkCreate",
          GetLastProcessCd: "MM10060/GetLastProcessCd",
          PrintSetting: "MM10060/PrintSetting",
          PrintClient: "MM10060/PrintClient",
          ChangeStartTime: "MM10060/ChangeStartTime",
          GetProcInfo: "MM10060/GetProcInfo",
        },
        MM10070: {
          GetWork: "MM10070/GetWork",
          GetBomWork: "MM10070/GetBomWork",
          GetProcWork: "MM10070/GetProcWork",
        },
        MM10080: {
          GetDayRead: "MM10080/GetDayRead",
        },
      },
      DataBase: {
        DB10010: {
          GetWorkOrder: "DB10010/GetWorkOrder",
        },
        DB10020: {
          GetWorkOrder: "DB10020/GetWorkOrder",
        },
        DB10030: {
          GetDelivery: "DB10030/GetDelivery",
          GetProc: "DB10030/GetProc",
          GetSalesOrders: "DB10030/GetSalesOrders",
        },
      },
    },
  },
};
